import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { EmailService } from '../../email/email.service';

@Component({
  selector: 'app-smtpemail',
  templateUrl: './smtpemail.component.html',
  styleUrls: ['./smtpemail.component.css']
})
export class SmtpemailComponent implements OnInit {

  public groupId: number;
  public forf: number;
  public status: boolean = false;
  public edit: any
  public password = 'password';
  public show = false;
  public username: string
  public idd: number
  public isother: Boolean = false;
  public issubimitted: boolean = false;
  public fullrecord: any[] = [];
  olduname:any
  form = new FormGroup({
    id: new FormControl('-1'),
    type: new FormControl('1', [Validators.required]),
    from_name: new FormControl('', [Validators.required]),
    // from_email:new FormControl('',[Validators.required,Validators.email]),
    smtp_username: new FormControl('', [Validators.required]),
    smtp_password: new FormControl('', [Validators.required]),
    status: new FormControl('0'),
  });
  
  constructor(@Inject(MAT_DIALOG_DATA) private Fdata: any, private dialogRef: MatDialogRef<any>, protected data: EmailService, protected msg: MatSnackBar,) { }

  ngOnInit() {
   
    console.log("this.Fdata :::", this.Fdata);
    if (this.Fdata.edit > 0)
      this.edit = this.Fdata.edit;
    else
      this.edit = '';

    if (this.Fdata.groupid != '') {
      this.groupId = this.Fdata.groupid;
      console.log("group id here", this.groupId)
    } else {
      if (this.Fdata.data.smtp_provider > '4') {
        this.username = this.Fdata.data.username;
        this.idd = this.Fdata.data.id;
        console.log(" Other coming here :: form patch");
        this.isother = true;
        this.otherformpatch(this.Fdata.data)
      }
      else {
        console.log("coming here :: form patch");
        this.username = this.Fdata.data.username;
        this.idd = this.Fdata.data.id;
        this.isother = false;
        this.formPatch(this.Fdata.data)
      }
    }

    if (this.Fdata.edit > 0) {
      console.log("dasdas")
      this.formPatch(this.Fdata.data)
    }
    console.log("checking id and user name", this.idd,);
    this.listfullEmail();
  }

  changeSmtp(e: any) {
    if (e.target.value == 5) {
      this.isother = true;
      this.addOtherControls()
    } else {
      this.isother = false;
    }
  }

  listfullEmail() {
    let where = 'es.`group_id`=' + this.groupId;
    console.log(where, "oo", this.groupId)
    this.data.getlistemailbyID(where).subscribe((res: any) => {
      console.log("gettng res", res);
      if (!res.error) {
        if (this.edit > 0) {
          this.fullrecord = res.filter((ele) => ele.id != this.idd && ele.username != this.username);
          console.log("on edit data here :::", this.fullrecord);
        } else {
          this.fullrecord = res;
        }
      }
    }, err => {
      this.fullrecord
      console.error("err::", err)
    })

    // this.data.listfullemail().subscribe((res: any) => {
    //   console.log("getting result here fulldata :::=>", res);
    //   if (!res.error) {
    //     if (this.edit > 0) {
    //       this.fullrecord = res.filter((ele) => ele.id != this.idd && ele.username != this.username);
    //       console.log("on edit data here :::", this.fullrecord);
    //     } else {
    //       this.fullrecord = res;
    //     }
    //   }
    // }, err => {
    //   this.fullrecord
    //   console.error("err::", err)
    // })
  }

  addOtherControls() {
    this.form = new FormGroup({
      id: new FormControl('-1'),
      type: new FormControl('5', [Validators.required]),
      from_name: new FormControl('', [Validators.required]),
      // from_email:new FormControl('',[Validators.required,Validators.email]),
      smtp_username: new FormControl('', [Validators.required]),
      smtp_password: new FormControl('', [Validators.required]),
      domain: new FormControl('', [Validators.required]),
      smtp_port: new FormControl('', [Validators.required]),
      status: new FormControl('0'),
    });
  }

  closeForm() {
    this.form = new FormGroup({
      id: new FormControl('-1'),
      type: new FormControl('1', [Validators.required]),
      from_name: new FormControl('', [Validators.required]),
      // from_email:new FormControl('',[Validators.required,Validators.email]),
      smtp_username: new FormControl('', [Validators.required]),
      smtp_password: new FormControl('', [Validators.required]),
      status: new FormControl('0'),
    });
  }

  onchangestatus(e: any) {
    if (e.checked == true)
      this.form.patchValue({ status: 1 })
    else
      this.form.patchValue({ status: 0 })
  }

  close() {
    let action = 0;
    this.closeDialog(action)
  }

 onSubmit() {
    if (this.form.invalid) {
      this.issubimitted = true;
    } else {
      const found = this.fullrecord.find((element) => element.username == this.form.value.smtp_username);
      console.log("find dublicate name ::::", found, this.olduname);
      if (found == undefined) {
        console.log("value1", found)
        let action = 1;
        this.closeDialog(action);
        // this.fullrecord = []
      } else if (this.olduname == found.username){
        console.log("value2", found.username)
        let action = 1;
        this.closeDialog(action);
        // this.fullrecord = []
      }else{
        this.openSnackBar('Username is already exist', 'clear');
      }

    }
  }


  onClick() {
    if (this.password === 'password') {
      this.password = 'text';
      this.show = true;
    } else {
      this.password = 'password';
      this.show = false;
    }
  }

  closeDialog(action: number) {
    this.dialogRef.close({ data: this.form.value, idgroup: this.groupId, isaction: action });
  }

  formPatch(data: any) {
    console.log("form data :::");

    // if(data.status==1){
    //   this.status=true;
    // }else{
    //   this.status=false;
    // }
    console.log("for patch data ::", data);
    this.olduname = data.username
    this.form.patchValue({
      id: data.id,
      type: data.smtp_provider,
      from_name:data.from_name,
      from_email: data.from_email,
      smtp_username: data.username,
      smtp_password: data.password,
      status: data.status,
    })
  }

  otherformpatch(data: any) {
    console.log("getting log here done ::::++ ", data);

    this.addOtherControls();
    this.form.patchValue({
      id: data.id,
      type: data.smtp_provider,
      from_name:data.from_name,
      from_email: data.from_email,
      smtp_username: data.username,
      smtp_password: data.password,
      status: data.status,
      domain: data.domain,
      smtp_port: data.smtp_port,
    })
  }
  openSnackBar(message: string, action: string) {
    this.msg.open(message, action, {
      duration: 3000
      , verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: ['snackbarwarn']
    });
  }
}
